export default {
  data() {
    return { tableColumns: [] };
  },
  methods: {
    buildTableColumns(columns = []) {
      if (columns.length > 0) {
        this.tableColumns = columns;
      } else {
        this.tableColumns = [
          {
            prop: "disabled",
            label: "状态",
            showColumn: true,
            width: 100,
            align: "center",
            fixed: "left",
            sortable: "custom"
          },
          {
            prop: "code",
            label: "编号",
            minWidth: 150,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "productNameCn",
            label: "产品中文名",
            minWidth: 120,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "productNameEn",
            minWidth: 120,
            label: "产品英文名",
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "specificationDescription",
            minWidth: 120,
            label: "产品规格",
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "effectNameCn",
            minWidth: 120,
            label: "效果中文名",
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "effectNameEn",
            minWidth: 120,
            label: "效果英文名",
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "usages",
            minWidth: 100,
            label: "用途",
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "rmbPerTileForSGrade",
            minWidth: 150,
            label: "优等品片单价",
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "rmbPerSquareForSGrade",
            minWidth: 150,
            label: "优等品平方单价",
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "rmbPerTileForAGrade",
            minWidth: 150,
            label: "一级品片单价",
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "rmbPerSquareForAGrade",
            minWidth: 150,
            label: "一级品平方单价",
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "seq",
            label: "次序",
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "user_name_create",
            label: "创建人",
            width: 100,
            showColumn: true,
            align: "left",
            sortable: "custom"
          },
          {
            prop: "utc_create",
            label: "创建时间",
            width: 120,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "user_name_modified",
            label: "更新人",
            width: 100,
            showColumn: true,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "utc_modified",
            label: "更新时间",
            showColumn: true,
            width: 120,
            align: "center",
            sortable: "custom"
          },
          {
            prop: "controlColumn",
            fixed: "right",
            align: "center",
            showColumn: true,
            label: "操作",
            width: 130
          }
        ];
      }
    }
  }
};
